export const isSSR = (() => {
  try {
    return !(document !== undefined);
  } catch (e) {
    return true;
  }
})();
